import React from "react";
import List from '@mui/material/List';
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Booking from "./Booking";
import Typography from "@mui/material/Typography";
import { useAppSelector } from "@store/hooks";

const name = "BookingsList";

const BookingsList: React.FC = () => {
    const bookings = useAppSelector(({ state }) => state.BOOKING_DATA_SYNC)
    const filteredBookings = bookings.filter((b) => b.statusId === 99 && b.failedId === 0)

    return (
        (<Grid
            size={{
                xs: 12,
                sm: 12
            }}>
            <Paper elevation={4} sx={(theme) => ({
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                padding: theme.spacing(1),
                width: "22.0rem",
            })}>
                <Typography sx={{ textAlign: "center" }}>Total: {filteredBookings.length}</Typography>
                <List component="nav" aria-label="main mailbox folders" sx={{ height: "25.1rem", overflow: "auto" }}>
                    {filteredBookings.map((booking) => (
                        <Booking key={booking.jobId} jobId={booking.jobId} statusId={booking.statusId} date={booking.date} />
                    ))}
                </List>
            </Paper>
        </Grid >)
    );
}
BookingsList.displayName = name
export default React.memo(BookingsList)